/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_Online_DescInputs */

const en_fc_home_paths_online_desc = /** @type {(inputs: Fc_Home_Paths_Online_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find browser access options, launch an available hosted editor or set up the web build yourself.`)
};

/**
* | output |
* | --- |
* | "Find browser access options, launch an available hosted editor or set up the web build yourself." |
*
* @param {Fc_Home_Paths_Online_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_online_desc = /** @type {((inputs?: Fc_Home_Paths_Online_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_Online_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_online_desc(inputs)
});
export { fc_home_paths_online_desc as "fc.home.paths.online.desc" }